






















































































































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import { DropdownLight } from '@/shared/dropdown-light';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { ScrollView } from '../scroll-view';
import UUIFComponents from '@/shared/uuifComponent';
import DefconProgress from '@/modules/msw-products/components/defcon-progress.vue';
import { RootStoreState } from '../../../store';
import { State } from 'vuex-class';
import { DashBoardStoreState } from '..';
import { confirmService, ConfirmOptions } from '@libs-uuif/shared/confirm-service/confirm.service';
import { ConfirmButton } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import idb, { PRODUCTS_STORE_NAME } from '@/services/indexedDb.service';
import  { MswApiService } from '@/shared/msw-api-service';
import { InfoState } from '@/core';
import localForageService from '@/services/localForageUpdate.service';

const cssPrefix = 'msw-widget-unit';

@Component({
  components: {
    DropdownLight,
    ...UUIFComponents,
    ScrollView,
    DefconProgress,
  },
  directives: {
    tooltip,
  },
})
export default class WidgetUnit extends SwExtendedVue{

  cssPrefix = cssPrefix;
  value: string = 'Edit';
  editingThis: boolean = false;
  newName: string = '';
  isFocus: boolean = false;
  isBoxFocused: boolean = false;
  editOrDelete: SelectOption[] = [];
  confirmService: any = confirmService;
  options: ConfirmOptions;
  buttons: ConfirmButton[];
  enablerenameTenentTooltip:boolean = false;
  renameTenentTooltipContent:string = '';

  @State((state: RootStoreState) => state.DashBoardStoreModule.allCustomers)
  customersDetails: DashBoardStoreState['allCustomers'];

  @Prop({ default: {}, required: true })
  widgetInfo: any;

  @Prop({ type:Number, default: 0, required: true })
  widgetIndex: number;

  private onFocus(event: MouseEvent) { this.$emit('focus', event); }

  get getIndex() {
    return this.widgetIndex;
  }

  get renameTenentTooltipValue() : TooltipDirValues  {
    return {
      enabled: this.enablerenameTenentTooltip,
      placement: 'top',
      persistent: true,
      compact: true,
      content: this.renameTenentTooltipContent,
    };
  }

  editOrDeleteToggleFunction() {
    switch (this.value){
      case 'edit':
        this.editingThis = true;
        this.$nextTick(() => { ((this.$el.childNodes[0].childNodes[0].childNodes[0].firstChild) as HTMLElement).focus(); });
        this.newName = this.widgetInfo['customerName'];
        this.isFocus = true;
        break;

      case 'delete':
        this.deleteWidget(this.widgetInfo.customerId);
        break;
    }
  }

  changeDefaultTenant(id: any) {
    const options: ConfirmOptions = {
      status: 'major',
      title: 'Confirmation',
      message: this.$t('workflow.dashboard.cnfrmDefaultTenantMsg')
        .toString(),
      buttons: this.buttons,
    };
    confirmService.confirm(options)
    .then((key) => {
      if (key === 'yes') {
        this.$store.commit('startLoading');
        const makeDefaultGroup: any = {
          GroupId: id.toString(),
          mode: 'TENANT',
        };
        MswApiService.createCustomer.manageDefaultGroup(makeDefaultGroup)
          .then((resp: any) => {
            this.$store.commit('stopLoading');
            console.warn(resp);
            if (resp.operationStatus === 'NOK') {
              const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
              this.$store.commit('displayMessage', message);
            } else {
              const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
              this.$store.commit('displayMessage', message);
              // this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets');
              this.$emit('updateCustomerList', { default: { customerId: makeDefaultGroup.GroupId } });
            }
          });
      }
    });
  }

  handleFocusOut(e: Event) {
    if (this.isFocus) {
      setTimeout(() => { this.$nextTick(() => { if (e.target) this.editingThis = false; }); }, 10);
      this.isFocus = false;
    }
  }
  onInput(value: string) {
    this.enablerenameTenentTooltip = false;
    if (value.trim() !== '') {
      if (value.length > 50) {
        this.enablerenameTenentTooltip = true;
        this.renameTenentTooltipContent = this.$t('workflow.dashboard.renameTenantMsg')
        .toString();
        return;
      }
    }
    this.newName = value;
  }

  onBlur(e: Event) {
    this.newName = this.customersDetails[this.widgetIndex]['customerName'];
    if (this.isFocus) this.handleFocusOut(e);
  }

  cancelEditCustomer() {
    this.newName = this.customersDetails[this.widgetIndex]['customerName'];
    this.isFocus = false;
    this.editingThis = false;
  }

  editCustomerName() {
    if (this.newName !== '') {
      const name = this.newName;
      this.$store
        .dispatch('DashBoardStoreModule/renameCustomerInDB', {
          productGroupId: this.widgetInfo.customerId,
          newProductGroupName: this.newName,
          bSendMail: true,
        })
        .then((res) => {
          idb.refreshStore(PRODUCTS_STORE_NAME);
          if (res.msgCode === 'MSWAPP:UPDATEGROUPNAMESUCCESS') {
            if (this.$store.getters.isLargeCustomer) {
              Promise.all([
                this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets', false),
                MswApiService.createCustomer.getUserGroup(false),
              ])
              .then((resp: any) => {
                const newResp = localForageService.renameTenant(resp, this.widgetInfo.customerId, name);
                this.saveForageData(newResp[0], '');
                this.saveForageDataForUserGroup(newResp[1], '');
                this.$emit('updateCustomerList', { edit: { customerId: this.widgetInfo.customerId, newName: name } });
                this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
                this.$store.commit('stopLoading');
              });
            } else {
              this.$store.commit('stopLoading');
              this.$emit('updateCustomerList', { edit: { customerId: this.widgetInfo.customerId, newName: name } });
              this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
            }
          } else if (res.msgCode === 'MSWAPP:UPDATEGROUPNAMEFAILURE') {
            this.$store.commit('stopLoading');
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
            this.$store.commit('stopLoading');
          }
        });
      this.editingThis = false;
    }
  }
  saveForageData(newResponse : any , id: any) {
    MswApiService.createCustomer.saveProductsDetailList({}, newResponse)
    .then(() => {
      console.warn(id);
    });
  }
  saveForageDataForUserGroup(newResponse : any , id: any) {
    MswApiService.createCustomer.saveUserGroupList({}, newResponse)
    .then(() => {
      console.warn(id);
    });
  }

  updateStarCustomer(i: number, status: boolean, productGroupId: string) {
    if (this.widgetInfo.isEnableStarred) {
      this.$store.commit('DashBoardStoreModule/updateStarCustomer', { i, status });
      this.$store.commit('DashBoardStoreModule/filterCustomer', {});
      this.$store.commit('DashBoardStoreModule/sortCustomerByStar');
      this.$store.dispatch('DashBoardStoreModule/updateStarCustomerInDB', { productGroupId, status: status ? 'YES' : 'NO' })
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK') {
          const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
          this.$store.commit('displayMessage', message);
        }
        this.$emit('updateCustomerList', { starred: { customerId: productGroupId, enable: status } });
      });

    }
  }

  goToProduct() {
    // console.warn(this.widgetInfo);
    // const tanentEncoded = btoa(this.widgetInfo.customerName);
    // console.warn('printing encoded', tanentEncoded);
    this.$router.push({ path: `/m/feature/products?tenantid=${this.widgetInfo.customerId}` });
    window.parent.postMessage({
      redirectUrl : `/m/feature/products?tenantid=${this.widgetInfo.customerId}`,
    },                        '*');
  }

  deleteWidget(productGroupId: string) {
    confirmService.confirm(this.options)
    .then((key) => {
      if (key === 'yes') {
        this.$store.dispatch('DashBoardStoreModule/deleteCustomerInDB', { productGroupId })
        .then((res: any) => {
          if (res.operationStatus === 'OK') {
            this.$emit('updateCustomerList', { delete: { customerId: productGroupId } });
          // this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
            this.$store.commit('enqueueMessage', { infoType:'success', infoMsg:'The selected Tenant has been deleted' });
            this.$store.commit('DashBoardStoreModule/deleteCustomer', this.widgetIndex);
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
          }
          this.$store.commit('stopLoading');
        });
      } else {
      }
    });
  }

  created() {
    // console.log('Raekwon:: ', this.widgetInfo.showDefault === 'true');
    this.buttons = [
        { key: 'cancel', name: 'Cancel', isDefault: true },
        { key: 'yes', name: 'Yes' },
    ];
    this.options = {
      status: 'high',
      title: 'Confirmation',
      message: this.$t('workflow.dashboard.deleteTenantMsg')
        .toString(),
      buttons: this.buttons,
    };
    this.editOrDelete.push(
      {
        id: this.widgetInfo.canRename === 'true' ? 'edit' : '',
        label: this.$t('profile.rename')
        .toString(),
        value: 'Edit',
      },
    );
    // this.editOrDelete.push({ id: this.widgetInfo.isDefaultGroup === 'TRUE' ? '' : 'delete', label: 'Delete', value: 'Delete' });
    this.editOrDelete.push(
      {
        id: this.widgetInfo.canDelete === 'true' ? 'delete' : '',
        label: this.$t('common.delete')
        .toString(),
        value: 'Delete',
      },
    );
    this.newName = this.widgetInfo['customerName'];
  }
  compactTooltipValue(): TooltipDirValues {
    return {
      placement: 'top',
      persistent: false,
      compact: true,
      content: '',
    };
  }
}
